import { Mentions } from 'antd';
import styled from 'styled-components';

export default styled(Mentions)`
	// Add your styles here
`;
